"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
// Max stack size that cannot be exceeded. When exceeded, old undo history will be dropped
// to keep size under limit. This is kept at 10MB
var MAXSIZELIMIT = 1e7;
/**
 * A class to help manage undo snapshots
 */
var UndoSnapshots = /** @class */ (function () {
    function UndoSnapshots(maxSize) {
        if (maxSize === void 0) { maxSize = MAXSIZELIMIT; }
        this.maxSize = maxSize;
        this.snapshots = roosterjs_editor_dom_1.createSnapshots(maxSize);
    }
    /**
     * Check whether can move current undo snapshot with the given step
     * @param step The step to check, can be positive, negative or 0
     * @returns True if can move current snapshot with the given step, otherwise false
     */
    UndoSnapshots.prototype.canMove = function (delta) {
        return roosterjs_editor_dom_1.canMoveCurrentSnapshot(this.snapshots, delta);
    };
    /**
     * Move current snapshot with the given step if can move this step. Otherwise no action and return null
     * @param step The step to move
     * @returns If can move with the given step, returns the snapshot after move, otherwise null
     */
    UndoSnapshots.prototype.move = function (delta) {
        return roosterjs_editor_dom_1.moveCurrentSnapsnot(this.snapshots, delta);
    };
    /**
     * Add a new undo snapshot
     * @param snapshot The snapshot to add
     */
    UndoSnapshots.prototype.addSnapshot = function (snapshot) {
        roosterjs_editor_dom_1.addSnapshot(this.snapshots, snapshot);
    };
    /**
     * Clear all undo snapshots after the current one
     */
    UndoSnapshots.prototype.clearRedo = function () {
        roosterjs_editor_dom_1.clearProceedingSnapshots(this.snapshots);
    };
    return UndoSnapshots;
}());
exports.default = UndoSnapshots;
//# sourceMappingURL=UndoSnapshots.js.map